import { IsoCountryCode2Char } from '@rbilabs/common';

import { IPoints } from '@rbi-ctg/frontend';

const mapDefaults: Partial<Record<IsoCountryCode2Char | 'default', IPoints>> = {
  [IsoCountryCode2Char.CA]: {
    lat: 43.6531,
    lng: -79.3839,
    zoom: 5.2,
  },
  default: {
    lat: 43.6531,
    lng: -79.3839,
    zoom: 5.2,
  },
};

export default mapDefaults;
